// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"c80b720d","787":"1ac17ba0"}[chunkId] + ".chunk.js";
};